import React from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Misc from '@components/Misc';
import { Button, Grid, Typography } from '@ts/storybook';
import { Icon } from '@ts/storybook';
import { useAppDispatch } from '@redux/store';
import ImageUpload from './ImageUpload';
import { uploadFile } from '@services/ApiService';
import { globalActions } from '@redux/slices/states/global/globalSlice';
import { CElement, IForm } from '@ts/ui-models';

interface IDocumentTabProps extends IForm {
  values: CElement;
  entityTypeId: string;
}

const DocumentTab = (props: IDocumentTabProps) => {
  const { mode, onChange } = props;
  const tElement = props.values;
  const entityId = tElement.getID();
  const entityTypeId = props.entityTypeId ?? 'tsElement';
  const documents = tElement.documents ?? [];

  const dispatch = useAppDispatch();

  const isViewMode = mode === 'view';

  const [state, setState] = React.useState({
    showModalPhoto: false,
    photoFile: null,
  });

  //#region Handlers

  const _handleUploadPhotoSuccess = document => {
    let updatedDocuments = documents;
    /* if (document.purposeId === 'default') {
      updatedDocuments = documents.filter(doc => doc.purposeId !== 'default');
    } */

    updatedDocuments = [...updatedDocuments, document];
    console.log('updatedDocuments', updatedDocuments);
    onChange && onChange('documents', updatedDocuments);
  };

  const _handleUploadPhoto = async ({ imageName, purposeId, photoFile }) => {
    if (photoFile != null) {
      const document = await uploadFile(
        dispatch,
        {
          name: imageName,
          purposeId: purposeId,
          entityTypeId: entityTypeId,
          entityId: entityId,
          mediaType: photoFile.type,
          //temporary: true,
          //private: true,
          //scopeCat: 'organization',
          isSystem: false,
        },
        photoFile
      );

      if (document) {
        _handleUploadPhotoSuccess(document);
      }
    } else {
      dispatch(globalActions.notification('No file.'));
    }
    return setState({ ...state, showModalPhoto: false });
  };

  //#endregion

  //#region Functions
  const _removeImage = id => () => {
    const filteredImages = documents.filter(document => document.id !== id);
    onChange && onChange('documents', filteredImages);
  };
  //#endregion

  //#region Render
  const renderAddNewDocument = () => {
    if (isViewMode) return null;

    return (
      <Grid size={12} mb={2}>
        <Button
          disabled={isViewMode}
          onClick={() => setState({ photoFile: null, showModalPhoto: true })}
          startIcon={<Icon className="text-xl mr-2" icon="content-add" />}
          label="New document"
        />
        <ImageUpload
          openModal={state.showModalPhoto}
          onUploadPhoto={_handleUploadPhoto}
          onClose={() => setState({ ...state, showModalPhoto: false })}
        />
      </Grid>
    );
  };

  const renderItemImages = () => {
    return (
      <Grid size={12}>
        <Misc.NewPaperWithPadding>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography className="font-medium" text="Name" />
                </TableCell>
                <TableCell>
                  <Typography className="font-medium" text="Type" />
                </TableCell>
                <TableCell>
                  <Typography className="font-medium" text="Image" />
                </TableCell>
                <TableCell>
                  <Typography className="font-medium" text="Remove" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {documents
                ?.filter(doc => doc.purposeId !== 'default')
                .map(row => {
                  let loading = false;
                  let src = row.locator && row.locator.constructor === Object ? row.locator.data : row.locator;

                  return (
                    <TableRow key={row.id}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell>{(row.purpose && row.purpose.name) || row.purposeId}</TableCell>
                      <TableCell>
                        {loading && <Misc.Loading type="circular" />}
                        {!loading && <img style={{ maxWidth: '100px', maxHeight: '100px' }} src={src} />}
                      </TableCell>
                      <TableCell>
                        <Button variant="outlined" disabled={isViewMode} onClick={_removeImage(row.id)}>
                          <Icon icon="action-delete" />
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </Misc.NewPaperWithPadding>
      </Grid>
    );
  };

  //#endregion

  return (
    <Grid container size={12}>
      {renderAddNewDocument()}
      {renderItemImages()}
    </Grid>
  );
};

export default DocumentTab;
